module.exports = __webpack_public_path__ + "img/31.427c79be.jpg";